import numeral from 'numeral';
 
export function numberAbbreviation(numValue: any): string {
  if (isNaN(numValue)) {
    return numValue;
  }
  let result = numeral(numValue).format('0.[00]a');
  if (result !== 'NaN') return result;
  result = numeral(numValue).format('0.00e+0');
  if (result !== 'NaN') return result;
  return numValue;
}